import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DecisionMemoryHeaderProps {
  onClose?: () => void;
}

const DecisionMemoryHeader: React.FC<DecisionMemoryHeaderProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-2 flex items-center justify-between gap-2">
      <h2 className="revy-cjk text-base font-semibold leading-[1.5]">
        {t('drbfm.decisionMemory.title', '設計判断メモリ')}
      </h2>
      {onClose && (
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={onClose}
          aria-label={t('drbfm.decisionMemory.close', '設計判断メモリを閉じる')}
        >
          <X strokeWidth={1.9} />
        </Button>
      )}
    </div>
  );
};

export default DecisionMemoryHeader;
